declare namespace $ {

	type $mol_string_button__hint_hyoo_tree_edit_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_hyoo_tree_edit_2 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_type'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__enabled_hyoo_tree_edit_3 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['enabled'] >
		,
		ReturnType< $mol_string_button['enabled'] >
	>
	type $mol_string__hint_hyoo_tree_edit_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_hyoo_tree_edit_5 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_hyoo_tree_edit_6 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['enabled'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_check_icon__hint_hyoo_tree_edit_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_hyoo_tree_edit_8 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_kind'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__enabled_hyoo_tree_edit_9 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['enabled'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__sub_hyoo_tree_edit_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_icon['sub'] >
	>
	type $mol_button_minor__hint_hyoo_tree_edit_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_hyoo_tree_edit_12 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_born'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_hyoo_tree_edit_13 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_hyoo_tree_edit_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_hyoo_tree_edit_15 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_delete_self'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_hyoo_tree_edit_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_hyoo_tree_edit_17 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_delete_tree'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_hyoo_tree_edit_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_hyoo_tree_edit_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_pick__hint_hyoo_tree_edit_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_enabled_hyoo_tree_edit_21 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['enabled'] >
		,
		ReturnType< $mol_pick['trigger_enabled'] >
	>
	type $mol_pick__trigger_content_hyoo_tree_edit_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_hyoo_tree_edit_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_hyoo_tree_edit_24 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['item_row'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_hyoo_tree_edit_25 = $mol_type_enforce<
		ReturnType< $hyoo_tree_edit['list'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_hyoo_tree_edit_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $hyoo_tree_edit extends $mol_list {
		item_type( id: any, next?: string ): string
		Item_type( id: any): $mol_string_button
		item_value( id: any, next?: string ): string
		Item_value( id: any): $mol_string
		item_kind( id: any, next?: boolean ): boolean
		Item_kind_icon( id: any): $mol_icon_translate
		Item_kind( id: any): $mol_check_icon
		item_born( id: any, next?: any ): any
		Item_born_icon( id: any): $mol_icon_plus
		Item_born( id: any): $mol_button_minor
		Item_delete_icon( id: any): $mol_icon_delete_outline
		item_delete_self( id: any, next?: any ): any
		Item_delete_self( id: any): $mol_button_minor
		item_delete_tree( id: any, next?: any ): any
		Item_delete_tree( id: any): $mol_button_minor
		Item_delete_options( id: any): $mol_list
		Item_delete( id: any): $mol_pick
		item_row( id: any): readonly(any)[]
		Item_row( id: any): $mol_view
		List( id: any): $mol_list
		Item( id: any): $mol_list
		list( id: any): readonly(any)[]
		value( next?: $mol_tree2 ): $mol_tree2
		enabled( ): boolean
		rows( ): ReturnType< $hyoo_tree_edit['list'] >
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map